// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-board{display:flex;align-items:center;justify-content:center;border:1px solid #e4e7ed;margin-top:20px;padding:20px 0;height:160px}.svg-board>svg{height:100%!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
